import { render, staticRenderFns } from "./SingleVendor.vue?vue&type=template&id=2492c96b"
import script from "./SingleVendor.vue?vue&type=script&lang=js"
export * from "./SingleVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports